module.exports = __webpack_public_path__ + "img/pricing-img-free.9db3ac86.png";